import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/header/header-image-2.png'


const _hoisted_1 = { id: "header-container" }
const _hoisted_2 = { id: "header-left" }
const _hoisted_3 = { id: "header-title" }
const _hoisted_4 = { id: "header-sub-title" }
const _hoisted_5 = { id: "header-button-container" }
const _hoisted_6 = {
  class: "header-link",
  id: "header-learn-more",
  href: "#about-us"
}
const _hoisted_7 = {
  class: "header-link rent-an-office-btn",
  href: "/offices"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { id: "header-right" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "header-img-container" }, [
    /*#__PURE__*/_createElementVNode("img", {
      id: "header-img",
      src: _imports_0,
      alt: "Header image"
    })
  ])
], -1)

import AboutUs from "@/components/AboutUs.vue";
import PartnersView from "@/components/PartnersView.vue";
import ContactUs from "@/components/ContactUs.vue";
import {getCurrentInstance} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


const instance = getCurrentInstance();
const translator = instance?.appContext.config.globalProperties.$translatorUtils;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(translator).trans("general.header.welcome_to")) + " Innovators Hub ", 1),
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_unref(translator).trans("general.header.sub_title")), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", _hoisted_6, _toDisplayString(_unref(translator).trans("general.header.learn_more")), 1),
            _createElementVNode("a", _hoisted_7, [
              _createElementVNode("span", null, _toDisplayString(_unref(translator).trans("general.header.rent_office")), 1)
            ])
          ])
        ]),
        _hoisted_8
      ])
    ]),
    _createElementVNode("main", null, [
      _createVNode(AboutUs),
      _createVNode(PartnersView),
      _createVNode(ContactUs)
    ])
  ], 64))
}
}

})